import request from '@/utils/request'

export function addServiceScore(data) {
  return request.post('/wxfwh/evaluate-add', data)
}

export function getServiceScoreList(data) {
  return request.post('/wxfwh/evaluate-list', data)
}



// WEBPACK FOOTER //
// ./src/api/service-score.js